<template>
  <li class="header-buttons d-flex not-logged-in-nav">
    <button class="btn btn-solid" @click="$bvModal.show('login')">
      {{ _T('Login') }}
    </button>
    <button class="btn btn-solid" @click="$bvModal.show('signup')">
      {{ _T('Register') }}
    </button>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NotLoggedInNav',
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.header-buttons {
  display: flex;
  .btn {
    height: $px40;
    width: $px100;
    padding: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    + .btn {
      margin-left: $px10;
      margin-right: $px10;
    }
  }
}
@media (max-width: 767px) {
  .header-buttons {
    display: none !important;
  }
}
</style>
